import React, { Component } from 'react'
import classnames from 'classnames'

import './Header.css'
import './Portfolio.css'
import './Resume.css'

export default class Header extends Component {
  constructor (props) {
    super(props)

    this.state = {
      section: this.props.selected ? 'Resumé' : 'Porfolio'
    }

    this.updateClassNames(props.selected)
  }

  updateClassNames (selected) {
    this.classNames = classnames({
      'djs-header': true,
      'djs-header--selected': selected
    })
  }

  select (e) {
    this.updateClassNames(true)
    this.props.select()
    // Redux action, set section.
    this.setState({ section: 'Resumé' })
  }

  deselect (e) {
    this.updateClassNames(false);
    this.props.deselect();
    this.setState({ section: 'Portfolio' })
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      section: nextProps.selected ? 'Resumé' : 'Porfolio'
    })

    this.updateClassNames(nextProps.selected)
  }

  renderResumeItems () {
    let workItems = [
      {
        'date': 'January 2015 – Present',
        'title': 'Lead Software Engineer',
        'location': 'EPAM Systems (Formerly Navigation Arts); Remote',
        'description': `I lead multiple teams building high intensity websites and web applications and mentor junior and senior developers (remote onshore and offshore). I help developers reach their career goals and become stronger team members. I perform regular code and architectural reviews, design and build full stack architectures, and interview and hire talented developers.`
      },
      {
        'date': 'January 2017 – July 2017',
        'title': 'Adjunct Instructor: Full Stack Bootcamp',
        'location': 'Georgia Tech; Savannah, GA',
        'description': `Taught a 6-month intensive bootcamp course on full stack Javascript development. Mentoring and growing new developers with no previous experience into strong individual contributors. I also acted as SCRUM master and team lead on over 20 ambitious student-built projects in a 6 month period.`
      },
      {
        'date': 'June 2011 – January 2015',
        'title': 'Lead Interactive Developer',
        'location': 'BFG Communications; Hilton Head, SC',
        'description': `Built high visibility websites and interactive marketing material and acted as a team lead (5 developers) and project organizer. Contributed dozens of games and several mobile applications as well as fully functional websites with customized content management systems.`
      },
      {
        'date': 'October 2010 – March 2011',
        'title': 'Actionscript Assassin (Flash Developer)',
        'location': 'Vision 3 Communications; Indianapolis, IN',
        'description': `Worked as an individual contributor building rich web applications, interactive prototypes and touch-screen kiosks for highly engaging trade-show experiences and museum exhibits. I also created several marketing websites and created multitouch frameworks for future touch-screen kiosk developers.`
      },
      {
        'date': 'June 2009 – October 2010',
        'title': 'Multimedia Developer, Instructor',
        'location': 'Ball State University, Emerging Technologies',
        'description': `As a founding member of the Emerging Technologies department at Ball State University I taught for-credit courses in multimedia and web development. I also lead, mentored, and trained teams of students creating applications and games for IOS and Android. I also lead research and development efforts into augmented reality, quad-copter drones and immersive virtual classrooms.`
      }
    ]

    workItems = workItems.map((item, index, arr) => {
      return <div className='djs-resume__work--item' key={index}>
        <div className='djs-resume__work--date'>{item.date}</div>
        <div className='djs-resume__work-title'>{item.title}</div>
        <div className='djs-resume__work-location'>{item.location}</div>
        <div className='djs-resume__work-description'>{item.description}</div>
      </div>
    })

    return workItems
  }

  render () {
    return (
      <header
        tabIndex='1'
        className={this.classNames}
        onFocus={this.select.bind(this)}
        onBlur={this.deselect.bind(this)}
      >
        <h1 className='djs-header__h1'><img src='https://s3.amazonaws.com/djs-portfolio/logo.svg' alt="Dustin Sparks's Logo" className='djs-header__logo' /> Dustin Sparks</h1>
        <h2 className='djs-header__h2'>{this.state.section}</h2>
        <div className='djs-portfolio'>
          <section className='djs-portfolio_container'>
            <h1 className='djs-resume__title'>Dustin Sparks</h1>
            <h2 className='djs-resume__subtitle'>Software Engineer and Educator</h2>
            <hr className='djs-resume__divider' />
            <h3 className='djs-resume__experience-title'>Professional Experience</h3>
            <div className='djs-resume__experience'>
              { this.renderResumeItems() }
            </div>
            <hr className='djs-resume__divider' />
            <h3 className='djs-resume__experience-title'>Professional Use of Technologies Over Time</h3>
            <img className='djs-portfolio__image' src='https://s3.amazonaws.com/djs-portfolio/Resume/technologies2.svg' alt="Dustin Sparks's Technology Experience" width='100%' />
          </section>
        </div>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js